import { MASTER_SUBSCRIPTION_ID, MONTHLY_SUBSCRIPTION_ID, SUBSCRIPTIONS } from '../constants';
import type { SubscriptionOption } from '../constants';

const MASTER_DEGREE_TYPE = 'master';

export const getSubscriptionForDegree = (degreeType?: string): SubscriptionOption => {
  const subscriptionId =
    degreeType === MASTER_DEGREE_TYPE ? MASTER_SUBSCRIPTION_ID : MONTHLY_SUBSCRIPTION_ID;

  return (
    SUBSCRIPTIONS.find((subscription) => subscription.id === subscriptionId) ?? SUBSCRIPTIONS[0]
  );
};
